import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumberDirective } from './input-only-number.directive';
import { TimeoutDisablingDirective } from './timeout-disabling.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    OnlyNumberDirective,
    TimeoutDisablingDirective,
  ],
  exports: [
    OnlyNumberDirective,
    TimeoutDisablingDirective,
  ],
})
export class DirectivesModule {}
